import React, { PureComponent } from 'react';
import Model from '../graph/model';
import Vertex from '../graph/vertex';
import Graph from '../graph/graph';
import FastOrganic from '../graph/fastorganic';
import VertexView from './VertexView';
import EdgeView from './EdgeView';


export default class View extends PureComponent<any, any> {
    done: boolean = true;
    cache: any = {};

    animate(): any {
        this.done = false;
        let dx: any;
        let dy: any;
        let ticks = 500;
        let current = 0;

        const vertices = document.getElementsByClassName('vertex');
        const edges = document.getElementsByClassName('edge');

        const dxs: any = {}
        const dys: any = {}

        let interval = setInterval(() => {                   
            if (current < ticks) {
                for (var i=0; i<vertices.length; i++) {
                    const element = vertices[i];
                    let id = element.getAttribute('id');
                    
                    if (id != null) {
                        id = id.split('-')[1];
                        const vertex = this.state.model.getAllVertices()[id];

                        if (current == 0) {
                            dxs[id] = vertex.getX() - vertex.currentX();
                            dys[id] = vertex.getY() - vertex.currentY();    
                        }
                        
                        dx = dxs[id]
                        dy = dys[id];

                        vertex.setCurrentX(vertex.currentX() + dx / ticks)
                        vertex.setCurrentY(vertex.currentY() + dy / ticks)

                        element.setAttribute("cx", vertex.currentX());
                        element.setAttribute("cy", vertex.currentY());
                    }
                }

                for (var j=0; j<edges.length; j++) {
                    const element = edges[j];
                    let id = element.getAttribute('id');

                    if (id != null) {
                        const parts = id.split('-');
                        const source = this.state.model.getAllVertices()[parts[1]];
                        const target = this.state.model.getAllVertices()[parts[2]];
                        
                        element.setAttribute("x1", source.currentX());
                        element.setAttribute("x2", target.currentX());
                        element.setAttribute("y1", source.currentY());
                        element.setAttribute("y2", target.currentY());                        
                    }
                }

                current++;
            } else {
                clearInterval(interval);
                this.done = true;
            }         
        }, 1000 / 24);

    }
    constructor(props: any){
        super(props);

        const model = new Model();
        const n1 = model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));
        const n2 = model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));
        const n3 = model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));
        const n4 = model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));
        const n5 = model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));
        model.addEdge(n1, n2);
        model.addEdge(n1, n3);
        model.addEdge(n2, n3);  
        model.addEdge(n4, n5);  
        model.addEdge(n3, n5);  
        
        const graph = new Graph(model, this.props.width, this.props.height, 20);
        const organic = new FastOrganic(graph);

        this.state = { 
            model: model,      
            nodes: [],
            edges: []      
        };

        setTimeout(() => {
            organic.execute();
        });
        

        
        setInterval(() => {
            if (!this.done) {
                return;
            }

            this.done = false;

            let changed = false;

            while (Object.keys(model.getAllVertices()).length < 8) {
                model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));    
            }

            if (Math.random() < 0.3) {
                model.add(new Vertex(model, Math.random() * this.props.width, Math.random() * this.props.height));    
                changed = true;
            }

            const vertices = model.getAllVertices();
            const edgeDel: any[] = [];

            const remAll: any = {};

            Object.values(vertices).forEach(a => {         
                let all = false
                if (Math.random() < 0.02) {
                    all = true;
                    remAll[a.getId()] = true;
                }

                Object.values(model.getEdges(model, a)).forEach(c => {
                    if (all || Math.random() < 0.1) {                       
                        edgeDel.push({src: a, trg: c});
                        changed = true;                                                    
                    }
                });
            });

            edgeDel.forEach(edge => {
                model.removeEdge(edge.src, edge.trg);
            })

            Object.values(vertices).forEach(a => {      
                Object.values(vertices).forEach(b => {
                    if (a.getId() !== b.getId() && Math.random() < 1 / model.getEdgeCount()) {  
                        if (a.getId() in remAll || b.getId() in remAll) {

                        } else {                                               
                            model.addEdge(a, b);
                            changed = true;                        
                        }
                    }
                }); 
            });
            

            const toDel: any[] = [];

            Object.values(vertices).forEach(a => {    
                if (Object.values(model.getEdges(model, a)).length == 0) {
                    toDel.push(a);
                    changed = true;
                }
            });

            toDel.forEach(a => {
                model.removeNode(a);
            });
            
            if (changed) {
                organic.execute();

                let j=0;
                const allNodes: { [id:string]: Vertex } = this.state.model.getAllVertices();
                const allEdges: { [id:string]: { [id:string]: Vertex } } = this.state.model.getAllEdges();

                const newCache: any = {}

                const nodes = Object.values(allNodes).map((vertex:Vertex) => {       
                    const isNew = !(vertex.getId() in this.cache);                    
                    newCache[vertex.getId()] = true;
                    return <VertexView new={isNew} model={this.state.model} key={vertex.getId()} vertex={vertex}></VertexView>
                });
                
                const edges: any[] = [];
                
                let i= 0;

                for (let src in allEdges) {   
                    for (let trg in allEdges[src]) {  
                        const key = allNodes[src].getId() + "-" + allNodes[trg].getId();
                        const isNew = !(key in this.cache)
                        if (!(key in newCache)) {
                            edges.push(<EdgeView new={isNew} key={key} model={this.state.model} source={allNodes[src]} target={allNodes[trg]}></EdgeView>);            
                            newCache[key] = true;
                        }
                    }
                }

                this.setState({
                    nodes: [],
                    edges: [],
                })

                this.forceUpdate(); 

                this.setState({
                    nodes, 
                    edges,
                });

                this.cache = newCache;
                
                this.forceUpdate(); 

                this.animate();
            }            
        }, 50);


    }


    render() {        
        

        return <svg style={{width: this.props.width + 'px', height: this.props.height +'px', backgroundColor: 'none'}}>
            {this.state.edges}
            {this.state.nodes}
        </svg>
    }
}
